import { useState } from "react";
import { useAuth } from "@/contexts/AuthContext";
import { MessageCircle, X } from "lucide-react";

const WHATSAPP_URL = "https://w.app/carlos_soglia";

/**
 * Floating WhatsApp support bubble.
 * Renders only when user is logged in. Bottom-right, above floating batch status.
 */
export default function WhatsAppBubble() {
  const { user } = useAuth();
  const [open, setOpen] = useState(false);

  if (!user) return null;

  return (
    <div className="fixed bottom-6 right-6 z-40" data-testid="whatsapp-bubble">
      {open && (
        <div
          className="absolute bottom-16 right-0 w-72 bg-white border border-zinc-200 rounded-md shadow-xl p-4 animate-in fade-in slide-in-from-bottom-2"
          data-testid="whatsapp-bubble-popup"
        >
          <div className="flex items-start justify-between mb-2">
            <div className="flex items-center gap-2">
              <div className="w-8 h-8 rounded-md bg-emerald-600 text-white flex items-center justify-center">
                <MessageCircle className="w-4 h-4" />
              </div>
              <div>
                <div className="text-sm font-semibold text-[#09090B]">Carlos Soglia</div>
                <div className="text-[10px] font-mono text-emerald-700">SUPORTE ONLINE</div>
              </div>
            </div>
            <button
              onClick={() => setOpen(false)}
              className="text-zinc-400 hover:text-zinc-700"
              data-testid="whatsapp-bubble-close"
              aria-label="Fechar"
            >
              <X className="w-4 h-4" />
            </button>
          </div>
          <p className="text-xs text-zinc-600 leading-relaxed mb-3">
            Olá! Travou em algum passo? Me chama direto no WhatsApp e resolvemos em minutos.
          </p>
          <a
            href={WHATSAPP_URL}
            target="_blank"
            rel="noreferrer"
            className="block w-full text-center bg-emerald-600 hover:bg-emerald-700 text-white text-sm font-medium rounded-md py-2 transition-colors"
            data-testid="whatsapp-bubble-cta"
          >
            Abrir WhatsApp →
          </a>
          <div className="text-[10px] font-mono text-zinc-400 mt-2 text-center">
            Seg–Sex · 9h às 18h (BRT)
          </div>
        </div>
      )}

      <button
        onClick={() => setOpen((v) => !v)}
        className="w-14 h-14 rounded-full bg-emerald-600 hover:bg-emerald-700 text-white shadow-lg hover:shadow-xl flex items-center justify-center transition-all hover:scale-105"
        data-testid="whatsapp-bubble-toggle"
        aria-label="Suporte WhatsApp"
      >
        <MessageCircle className="w-6 h-6" />
      </button>
    </div>
  );
}
